import dayjs from 'dayjs'
import 'dayjs/locale/sl'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.locale('sl')

export default dayjs

/** "15. 10. 2026" — the date format used everywhere in the UI (spec §11). */
export const formatDate = (value: string | null | undefined): string => {
    if (!value) return '—'
    return dayjs(value).format('D. M. YYYY')
}

/** "15. 10. 2026 14:32" */
export const formatDateTime = (value: string | null | undefined): string => {
    if (!value) return '—'
    return dayjs(value).format('D. M. YYYY HH:mm')
}

/** "15. 10. 2026 14:32:05" — audit log precision. */
export const formatDateTimeSeconds = (value: string | null | undefined): string => {
    if (!value) return '—'
    return dayjs(value).format('D. M. YYYY HH:mm:ss')
}

export const formatTime = (value: string | null | undefined): string => {
    if (!value) return '—'
    return dayjs(value).format('HH:mm')
}

/** Today in the user's timezone as "15. 10. 2026" (ValidityDate is always the report day). */
export const todayText = (): string => dayjs().format('D. M. YYYY')

/** YYYY-MM-DD for API date filters. */
export const isoDay = (value: Date | string): string => dayjs(value).format('YYYY-MM-DD')
